export default __webpack_public_path__ + "static/media/bigCommerce-p-500.30a54011.png";